import { FetchNews } from '~services/api/validators/Newsfeed';
import { parseImageCrops } from '~utils/imageCrop';
import { trimLeadingSlash } from '~utils/string';

export function createNews(data: FetchNews) {
  const newsList: NewsItem[] = data.map(item => {
    return {
      id: item.nid,
      title: item.meta_title || item.title || '',
      description: item.meta_description || item.change_description || '',
      pageAlias: trimLeadingSlash(item.path),
      imageSrc: item.meta_image,
      crops: parseImageCrops(item.meta_image_crops),
      topicIds: item.topics || [],
    };
  });

  return newsList;
}
